import { useEffect, useState } from 'react';
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import './Privacidade.css';
import { lerConsentimento, limparConsentimento, EVENTO_CONSENTIMENTO } from '../../consentimento';

const TEXTO_ESCOLHA = {
  aceito: 'Você aceitou os cookies de estatística.',
  recusado: 'Você recusou os cookies de estatística.',
};

const Privacidade = () => {
  const [escolha, setEscolha] = useState(lerConsentimento());

  useEffect(() => {
    const aoMudar = (e) => setEscolha(e.detail);
    window.addEventListener(EVENTO_CONSENTIMENTO, aoMudar);
    return () => window.removeEventListener(EVENTO_CONSENTIMENTO, aoMudar);
  }, []);

  return (
    <div>
      <Header />
      <main className="privacidade">
        <h1>Política de Privacidade e Cookies</h1>
        <p className="privacidade-data">Última atualização: outubro de 2026</p>

        <section>
          <h2>Quem somos</h2>
          <p>
            Este site pertence ao Colégio Líder, Rua José da Cunha, Quadra 126, Lotes 19/24,
            St. dos Afonsos, Aparecida de Goiânia - GO. Para qualquer assunto sobre seus dados,
            fale com a gente pelo e-mail{' '}
            <a href="mailto:recep@colegiolidergo.com.br">recep@colegiolidergo.com.br</a> ou pelo
            telefone <a href="tel:+556235480070">(62) 3548-0070</a>.
          </p>
        </section>

        <section>
          <h2>Quais dados o site coleta</h2>
          <p>
            O site não tem cadastro nem formulário: navegar por ele não exige que você informe
            nome, e-mail ou telefone.
          </p>
          <p>
            <strong>Somente se você aceitar os cookies</strong>, usamos o Google Analytics para
            gerar estatísticas de uso, como: quais páginas são mais visitadas, quanto tempo as
            pessoas ficam, se acessam pelo celular ou computador, a cidade aproximada e quais
            botões são mais clicados (por exemplo, o do WhatsApp). Essas informações chegam para
            nós de forma agregada e não identificam você pessoalmente.
          </p>
          <p>
            Se você recusar, nenhum cookie de estatística é usado e o site funciona normalmente.
          </p>
        </section>

        <section>
          <h2>Para que usamos essas informações</h2>
          <p>
            Apenas para entender como as famílias usam o site e melhorá-lo: deixar mais fácil
            encontrar as informações, corrigir problemas e saber quais canais de contato são
            mais úteis. Não vendemos dados e não usamos essas informações para propaganda.
          </p>
        </section>

        <section>
          <h2>Contato pelo WhatsApp, telefone e e-mail</h2>
          <p>
            Quando você clica em um botão de WhatsApp, telefone ou e-mail, a conversa acontece
            nesses aplicativos, fora do site. As informações que você nos enviar por lá são usadas
            somente para responder ao seu contato e para o atendimento da escola.
          </p>
        </section>

        <section>
          <h2>Conteúdos de outros sites</h2>
          <p>
            Algumas páginas mostram conteúdos de outros serviços — vídeos do Instagram e do
            YouTube, o mapa do Google e imagens guardadas no Google Drive. Esses serviços têm
            suas próprias políticas de privacidade.
          </p>
        </section>

        <section>
          <h2>Seus direitos</h2>
          <p>
            Pela Lei Geral de Proteção de Dados (Lei 13.709/2018), você pode pedir informações
            sobre o uso dos seus dados, correção ou exclusão, e pode mudar a sua escolha sobre os
            cookies a qualquer momento. Para isso, use o botão abaixo ou fale com a gente pelos
            contatos acima.
          </p>
        </section>

        <section className="privacidade-escolha">
          <h2>Sua escolha sobre cookies</h2>
          <p>{escolha ? TEXTO_ESCOLHA[escolha] : 'Você ainda não escolheu.'}</p>
          <button type="button" onClick={limparConsentimento}>
            Alterar minha escolha
          </button>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Privacidade;
